<template>
    <div class="special-event-grid">
        <div
            class="special-event-grid__scrollable-content--terminal special-wrapper-height"
        >
            <SpecialEventScrollable
                v-for="item in items"
                :key="item.id"
                :id="item.id"
                :markets="item.markets"
                :footer="item.footer"
                :header="item.header"
                :name="getName(item)"
                :date="getDate(item)"
                :isResults="isResults"
                :selections="selections"
                :isExpanded="isExpanded(item.id)"
                :isFull="item.isFull"
                @oddClick="(odd) => onOddClick(odd, item)"
                @eventClick="onEventClick"
                @rendered="onEventRendered"
                @collapse="(id) => onCollapse(id)"
            />
        </div>
    </div>
</template>

<script>
    import {
        sumBy as _sumBy,
        pick as _pick,
    } from '@lodash';
    import { setWindowScrollTop } from '@src/app/styles/scripts/uiHelpers';
    import SpecialEventScrollable from './SpecialEventScrollable.vue';
    import { SelectionType } from '@core/models/shared/betSlip/betSlipEnums';
    import SpecialGridPreparation, { specialGridState, SCROLLING_DISABLED } from './helpers';

    export default {
        name: 'SpecialGrid',
        props: {
            isResults: {
                type: Boolean,
                required: false,
                default: false
            },
            events: {
                type: Array,
                required: true
            },
            expandedEventId: {
                type: Number,
                default: null,
            },
            selections: {
                type: Array,
                required: false,
                default: () => [],
            },
            gridStartOffset: { // if not set, the scrolling is disabled (because of the competition page)
                type: Number,
                required: false,
                default: SCROLLING_DISABLED,
            },
        },
        data() {
            return {
                items: [],
                didChangeOpenState: true,
                childrenToRender: 0,
                childrenRenderDone: false,
            };
        },
        created() {
            if (this.expandedEventId !== null) {
                this.eventToScrollTo = this.expandedEventId;
                specialGridState.offsetTop = this.gridStartOffset;
                this.childrenToRender = 1;
            }
            this.$watch(
                function () {
                    return {
                        ..._pick(this, ['events', 'expandedEventId']),
                    };
                },
                this.defineContent,
                {
                    immediate: true
                }
            );
        },
        watch: {
            expandedEventId(newValue, oldValue) {
                this.childrenRenderDone = false;
                if (oldValue && newValue) {
                    this.childrenToRender = 2;
                } else {
                    this.childrenToRender = 1;
                }
                this.eventToScrollTo = newValue || oldValue;
            },
            childrenRenderDone(value) {
                if (value) {
                    this.adjustScrollPosition();
                }
            }
        },
        methods: {
            adjustScrollPosition() {
                if (this.gridStartOffset === SCROLLING_DISABLED) { // temporary way to disable scrolling
                    return;
                }

                this.scrollPosition = this.calculateScrollPosition();
                if (this.scrollPosition !== 0) {
                    setWindowScrollTop(this.scrollPosition - specialGridState.offsetTop + this.gridStartOffset);
                }
            },
            defineContent() {
                this.items = new SpecialGridPreparation(this.events).getContent();
            },
            onEventClick(eventId, clickEvent) {
                this.$emit('eventClick', eventId);
                specialGridState.offsetTop = clickEvent.currentTarget.parentElement.getBoundingClientRect().y;
            },
            onCollapse(eventId) {
                this.$emit('eventClick', eventId);
            },
            isExpanded(eventId) {
                return eventId === this.expandedEventId;
            },
            onOddClick(odd, event) {
                this.$emit('oddClick', {
                    type: SelectionType.special,
                    oddId: odd.id,
                    eventId: event.id,
                });
            },
            getName(event) {
                if (event.masterName) {
                    return `${event.masterName} - ${event.fullName}`;
                }
                return event.fullName;
            },
            getDate(event) {
                return event.date;
            },
            calculateScrollPosition() {
                let selectedEventIndex = this.items.findIndex((event) => event.id === this.eventToScrollTo);

                if (selectedEventIndex === -1) {
                    // prevent interpreting -1 as the last index in the slice
                    selectedEventIndex = 0;
                }

                const eventsBefore = this.items.slice(0, selectedEventIndex);
                return _sumBy(eventsBefore, 'height');
            },
            onEventRendered() {
                this.childrenToRender -= 1;
                if (this.childrenToRender === 0) {
                    this.childrenRenderDone = true;
                }
            }
        },
        components: {
            SpecialEventScrollable
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/special/SpecialGrid.vue